import { handleActions } from 'redux-actions'
import { getLife365ListOfProgramsSuccess, resetState } from '@tabeeb/modules/healthData/actions'

const defaultState = []

export default handleActions(
  {
    [getLife365ListOfProgramsSuccess](state, action) {
      return action.response.data
    },
    [resetState](state, action) {
      return defaultState
    },
  },
  defaultState
)
